const sampleTag = `<!--
 Id: [ID_PEDIDO]
 Campanha: [NOME_CAMPANHA]
 Agência: [NOME_AGENCIA]
 Publisher: [NOME_VEICULO]
 Anunciante: [NOME_CLIENTE]
 Canal: [SEGMENTACAO]
 Linha Criativa: [LINHA_CRIATIVA]
 Região: [REGIAO]
 Bloco de anúncio: [NOME_FORMATO]
 Tamanho: [TAMANHO_FORMATO]
 Data de Veiculação: [DATA_INICIO] - [DATA_TERMINO]
-->
<script data-cfasync="false" async src="https://cdn.adpulse.com.br/adpulse.js"></script>
<script>
  window.adpulse = window.adpulse || { cmd: [] };
  adpulse.cmd.push(function() {
    adpulse.run({
      campaignId: [ID_CAMPANHA],
      orderId: [ID_PEDIDO],
      macros: {
        click: '%%CLICK_URL_UNESC%%',
        adUnit: '%%ADUNIT%%',
        url: '%%PATTERN:url%%',
        targeting: %%PATTERN:TARGETINGMAP%%,
      },
    });
  });
</script>`;

export default sampleTag;
